import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MarkdownModule } from 'ngx-markdown';
import { MatDialogModule } from '@angular/material/dialog';
import { ChatbotDialogComponent } from './chatbot/chatbot-dialog.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({ declarations: [ChatbotDialogComponent],
    exports: [ChatbotDialogComponent], imports: [CommonModule,
        FormsModule,
        MatIconModule,
        MarkdownModule.forChild(),
        MatDialogModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class ChatbotModule {}